
import Vue from 'vue';
import BootstrapSelect from './components/BootstrapSelect';
import DateRangePicker from './components/DateRangePicker';

window.Vue = Vue;

Vue.component('bootstrap-select', BootstrapSelect);
Vue.component('date-range-picker', DateRangePicker);

Vue.directive('uppercase', {
    update(el) {
        el.value = el.value.toUpperCase();
    }
});

window.EventBus = {
    vue: new Vue(),
    fire(event, data) {
        EventBus.vue.$emit(event, data);
    },
    listen(event, callback) {
        EventBus.vue.$on(event, callback);
    },
    stopListening(event, callback) {
        EventBus.vue.$off(event, callback);
    },
};

